import * as types from "./mutation-types";
import CacheHelper from "@/cacheHelper";
import { isEmpty } from "lodash";

const cacheConfig = {
  key: "WIDGET_NEWS",
  ttl: 60 * 5 * 1000, // 5 mins
};

const cache = new CacheHelper(cacheConfig);

export const actions = {
  async setLimit({ commit }, limit) {
    commit(types.SET_FILTER_LIMIT, limit);
    return Promise.resolve(limit);
  },

  async clearCache(context) {
    cache.removeItem(cacheConfig.key);
    return Promise.resolve(cacheConfig.key);
  },

  async getLargestLimit({ rootGetters, commit }) {
    const newsWidgets = rootGetters["widgets/getWidgetsByType"]("news-widget");
    const limits = [];
    let largest = 10;
    if (!isEmpty(newsWidgets)) {
      newsWidgets.forEach((widget) => {
        limits.push(parseInt(widget.props.limit));
      });

      largest = limits.sort((a, b) => b - a)[0];
    }

    commit(types.SET_MAX_QUERY_SIZE, largest);
    return Promise.resolve(largest);
  },
  /**
   * Get a list of news items from the API.  Check local cache first and get data from there
   */
  async getNewsItems({ state, commit, dispatch, rootState }, localOptions) {
    let newsItems;

    // do we have a cache?
    if (cache.existsAndIsValid()) {
      newsItems = cache.getItem(cacheConfig.key);
      commit(types.ADD_NEWS, newsItems);
      return Promise.resolve(newsItems);
    }

    let userGroupIds = [];

    if (
      rootState.auth.currentUser.interestgroups &&
      rootState.auth.currentUser.interestgroups.length > 0
    ) {
      userGroupIds = rootState.auth.currentUser.interestgroups.map(
        (grp) => grp.id
      );
    }

    let query = {
      sort: [
        {
          created_time: {
            order: "desc",
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              terms: {
                interestgroups: [...userGroupIds, state.mftGroupId],
              },
            },
            {
              term: {
                status: "approved",
              },
            },
          ],
        },
      },
      size: state.largestQuerySize, // return the maximum number we need
    };

    if (state.status !== "WORKING") {
      commit(types.SET_STATUS, "WORKING");
      try {
        if (state.articles.length === 0) {
          newsItems = await dispatch(
            "News/query",
            {
              query,
              includeWeb: true,
            },
            { root: true }
          );
          commit(types.ADD_NEWS, newsItems);
          cache.setItem(cacheConfig.key, newsItems, true);
        } else {
          newsItems = state.articles;
        }
        commit(types.SET_STATUS, "WAITING");
        return Promise.resolve(newsItems);
      } catch (err) {
        commit(types.SET_STATUS, "WAITING");
        return Promise.reject(new Error(err));
      }
    }
  },
};
